import { Dialog, Typography } from '@material-ui/core';
import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import useStyles from './styles';
import CommunitySearch from '../../containers/CommunitySearch';
import PropertySearch from '../../containers/PropertySearch';
import CustomButton from '../CustomButton';

type Props = {
  open: boolean;
  onClose: () => void;
  builderId: number;
  handleChangeCommunity: (value: number, rest?: any) => void;
  handleChangeProperty: (value: number, rest?: any) => void;
  handleSend: () => void;
};

export const WebhookTestModal = ({
  open,
  onClose,
  builderId,
  handleChangeProperty,
  handleChangeCommunity,
  handleSend,
  }: Props) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: classes.modalWrapper,
      }}
    >
      <Typography variant="h5" className={classes.modalTitle}>
        Test Webhook
      </Typography>

      <DialogContent className={classes.modalContent}>
        <CommunitySearch
          handleChange={handleChangeCommunity}
          builderId={builderId}
        />
        <PropertySearch
          handleChange={handleChangeProperty}
        />
        <CustomButton
          className={classes.modalButton}
          variant="orange"
          onClick={handleSend}
        >
          Send
        </CustomButton>
      </DialogContent>

    </Dialog>
  );
};
